export const PHOTO_REVIEW_STATUS = Object.freeze({
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
});

export const REVIEW_REQUEST_STATUS = Object.freeze({
  APPLY_WAITING: "APPLY_WAITING",
});

export const normalizePhotoReviewStatus = (status) =>
  Object.values(PHOTO_REVIEW_STATUS).includes(status) ? status : null;

export const normalizeReviewRequestStatus = (status) =>
  Object.values(REVIEW_REQUEST_STATUS).includes(status) ? status : null;

// 再撮影で取り消した申請の写真は消さずに残り、写真の表には申請の ID がないため、申請まで辿って外す。
export const buildNotCanceledRequestPhotoClause = ({
  photoAlias = "ppa",
  photoIdExpression = `${photoAlias}.id`,
} = {}) => `
    NOT EXISTS (
      SELECT 1
      FROM review_image_info rii_canceled
      JOIN review_request_info_review_image_bind rririb_canceled
        ON rririb_canceled.review_image_info_id = rii_canceled.id
      JOIN review_request_review_request_info_bind rrpb_canceled
        ON rrpb_canceled.review_request_info_id = rririb_canceled.review_request_info_id
      JOIN review_request rr_canceled
        ON rr_canceled.id = rrpb_canceled.review_request_id
      WHERE rii_canceled.photo_of_power_asset_id = ${photoIdExpression}
        AND rr_canceled.status = 'CANCELED'
    )`;

export const buildPhotoReviewStatusExistsClause = ({
  photoAlias = "ppa",
  photoIdExpression = `${photoAlias}.id`,
  status,
  reviewReqIdInClause = "",
} = {}) => {
  const normalizedStatus = normalizePhotoReviewStatus(status);
  if (!normalizedStatus) return "";

  const reviewRequestFilter = reviewReqIdInClause
    ? `
      AND EXISTS (
        SELECT 1
        FROM review_request_info_review_image_bind rririb_request
        JOIN review_request_review_request_info_bind rrpb_request
          ON rrpb_request.review_request_info_id = rririb_request.review_request_info_id
        WHERE rririb_request.review_image_info_id = rii.id
          ${reviewReqIdInClause.replace(/rrpb\./g, "rrpb_request.")}
      )`
    : "";

  return `
    EXISTS (
      SELECT 1
      FROM review_image_info rii
      JOIN review_image_info_photo_review_result_bind prb
        ON prb.review_image_info_id = rii.id
      JOIN photo_review_result pr
        ON pr.id = prb.photo_review_result_id
      WHERE rii.photo_of_power_asset_id = ${photoIdExpression}
        AND pr.status = '${normalizedStatus}'
        AND ${buildNotCanceledRequestPhotoClause({ photoIdExpression })}
        ${reviewRequestFilter}
    )`;
};

export const buildPhotoReviewRequestStatusExistsClause = ({
  photoAlias = "ppa",
  photoIdExpression = `${photoAlias}.id`,
  status,
  reviewReqIdInClause = "",
} = {}) => {
  const normalizedStatus = normalizeReviewRequestStatus(status);
  if (!normalizedStatus) return "";

  const requestFilter = reviewReqIdInClause
    ? `\n        ${reviewReqIdInClause}`
    : "";

  return `
    EXISTS (
      SELECT 1
      FROM review_image_info rii
      JOIN review_request_info_review_image_bind rririb
        ON rririb.review_image_info_id = rii.id
      JOIN review_request_review_request_info_bind rrpb
        ON rrpb.review_request_info_id = rririb.review_request_info_id
      JOIN review_request rr
        ON rr.id = rrpb.review_request_id
      WHERE rii.photo_of_power_asset_id = ${photoIdExpression}
        AND rr.status = '${normalizedStatus}'${requestFilter}
    )`;
};

export const buildReviewFilterExistsClause = ({
  photoAlias = "ppa",
  photoIdExpression = `${photoAlias}.id`,
  status,
  reviewReqIdInClause = "",
} = {}) => {
  if (normalizeReviewRequestStatus(status)) {
    return buildPhotoReviewRequestStatusExistsClause({
      photoAlias,
      photoIdExpression,
      status,
      reviewReqIdInClause,
    });
  }
  return buildPhotoReviewStatusExistsClause({
    photoAlias,
    photoIdExpression,
    status,
    reviewReqIdInClause,
  });
};
